import { request } from "./http";

export interface TransactionReport {
  id: string;
  transaction_reference_number: string;
  fill_id: string | null;
  status: "PENDING" | "SUBMITTED" | "REJECTED" | "RESUBMITTED";
  arm_vendor: string | null;
  arm_submission_id: string | null;
  arm_submitted_at: string | null;
  arm_accepted_at: string | null;
  last_error: string | null;
  created_at: string;
}

export interface SubmitResult {
  considered: number;
  submitted: number;
  rejected: number;
}

export const transactionReports = {
  list: (params: { status?: TransactionReport["status"]; limit?: number } = {}) => {
    const qs = new URLSearchParams();
    if (params.status) qs.set("status", params.status);
    if (params.limit) qs.set("limit", String(params.limit));
    return request<TransactionReport[]>(
      `/api/v1/admin/rts22/reports${qs.toString() ? "?" + qs : ""}`,
    );
  },
  xmlUrl: (id: string) => `/api/v1/admin/rts22/reports/${id}/xml`,
  submitPending: () =>
    request<SubmitResult>("/api/v1/admin/rts22/submit-pending", { method: "POST" }),
};
